// Login
export * from "./logout.component";



// WEBPACK FOOTER //
// ./src/app/components/logout/index.ts